import {GET_INFO} from '/redux/action/currentUser.action';
import {getFullStoryUtilDefaultInstance} from '/util/fullstory';

export const trackUserProperties = () => (next: any) => (action: any) => {
  const {type: actionType, payload = {}} = action;

  return Promise.resolve(next(action)).then(() => {
    if (actionType === GET_INFO) {
      const {
        coach: {
          id,
          certified,
          rank: {id: rankId} = {},
          highestAchievedRank: {id: har} = {},
        } = {},
      } = payload;

      getFullStoryUtilDefaultInstance().trackUserProperties({
        userId: id,
        certification: certified,
        rank: rankId,
        har,
      });
    }
  });
};
